import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import Swal from 'sweetalert2';

// var Api = 'http://localhost:2304/nodeapp/';
var Api= "https://sbsdc.co.in:2304/nodeapp/";

@Injectable({
  providedIn: 'root'
})
export class WebService {
   errorMessageAlert(message: any) {
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: message,
      showCloseButton: true,
      showCancelButton: false,
      showConfirmButton: true,
      timer: 1500
    })
  }
  statusChangeAlert(message: any) {
    Swal.fire({
      icon: 'success',
      title: message,
      showConfirmButton: false,
      timer: 1500
    })
  }

  constructor(private http: HttpClient) { }

  getvideosData() {
    return this.http.get<any>(Api + `videos`).pipe(map(res => {
      return res;
    }, (error: any) => {
      return error;
    }));
  }
   submitcontactsData(data: any) {
    return this.http.post<any>(Api + `contacts`, data).pipe(map(res => {
      if (res.status == 200) {
        this.statusChangeAlert("Sucessfully Added..!")
      }
      else if (res.status == 300) {
        this.errorMessageAlert("Already Added..!")
      }
      else {
        this.errorMessageAlert("Server Error")
      }
      return res;
    }, (error: any) => {
      return error;
    }));
  }
}
